(() => {
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  let cleanups = [];

  const cleanup = () => {
    cleanups.forEach((remove) => remove());
    cleanups = [];
  };

  const setup = () => {
    cleanup();

    if (!mediaQuery.matches) return;

    const topButton = document.querySelector('[data-daochant-product-to-top]');
    if (topButton) {
      let topButtonTicking = false;
      const updateTopButton = () => {
        topButtonTicking = false;
        topButton.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.15);
      };
      const requestTopButtonUpdate = () => {
        if (topButtonTicking) return;
        topButtonTicking = true;
        window.requestAnimationFrame(updateTopButton);
      };
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };

      topButton.addEventListener('click', scrollToTop);
      window.addEventListener('scroll', requestTopButtonUpdate, { passive: true });
      window.addEventListener('resize', requestTopButtonUpdate);
      cleanups.push(() => {
        topButton.removeEventListener('click', scrollToTop);
        window.removeEventListener('scroll', requestTopButtonUpdate);
        window.removeEventListener('resize', requestTopButtonUpdate);
      });
      updateTopButton();
    }

    document.querySelectorAll('[data-daochant-mobile-product-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('.daochant-mobile-product-media__track');
      const dots = Array.from(carousel.querySelectorAll('[data-daochant-mobile-product-dot]'));

      if (!track || dots.length < 2) return;

      let ticking = false;
      const updateDots = () => {
        ticking = false;

        const width = track.clientWidth || 1;
        const index = Math.round(track.scrollLeft / width);
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateDots);
      };

      const handleDotClick = (event) => {
        const index = Number(event.currentTarget.dataset.slideIndex || 0);
        track.scrollTo({
          left: track.clientWidth * index,
          behavior: 'smooth',
        });
      };

      track.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      dots.forEach((dot) => dot.addEventListener('click', handleDotClick));
      cleanups.push(() => {
        track.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        dots.forEach((dot) => dot.removeEventListener('click', handleDotClick));
      });

      updateDots();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  mediaQuery.addEventListener('change', setup);
})();
